/** Pure helpers for tear sheet packs, dimensions, and imagery */

export const emptyPackRow = () => ({
  quantityPack: '',
  length: '',
  breadth: '',
  height: '',
  grossWt: '',
  barcodeTypeId: '',
});

export const rowFromApi = (row) => {
  if (!row || typeof row !== 'object') return emptyPackRow();
  return {
    quantityPack: row.quantityPack ?? row.quantity_pack ?? row.unit ?? '',
    length: row.length ?? '',
    breadth: row.breadth ?? '',
    height: row.height ?? '',
    grossWt: row.grossWt ?? row.netWt ?? row.net_wt ?? '',
    barcodeTypeId:
      row.barcodeTypeId !== undefined && row.barcodeTypeId !== null && row.barcodeTypeId !== ''
        ? String(row.barcodeTypeId)
        : '',
  };
};

export const normalizePackRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return [emptyPackRow()];
  return rows.map(rowFromApi);
};

export const serializePackRows = (rows) =>
  rows.map((row) => {
    const bt =
      row.barcodeTypeId === '' || row.barcodeTypeId === undefined || row.barcodeTypeId === null
        ? null
        : Number(row.barcodeTypeId);
    return {
      quantityPack: row.quantityPack || null,
      length: row.length === '' || row.length === undefined ? null : row.length,
      breadth: row.breadth === '' || row.breadth === undefined ? null : row.breadth,
      height: row.height === '' || row.height === undefined ? null : row.height,
      grossWt: row.grossWt === '' || row.grossWt === undefined ? null : row.grossWt,
      barcodeTypeId: bt !== null && !Number.isNaN(bt) ? bt : null,
    };
  });

export const formatDimensions = (p) => {
  const l = p?.length ?? p?.lengthDimension ?? '';
  const b = p?.breadth ?? p?.breadthDimension ?? '';
  const h = p?.height ?? p?.heightDimension ?? '';
  const u = p?.dimensionUnit ?? '';
  if (l === '' && b === '' && h === '') return '—';
  return `${l} × ${b} × ${h} ${u}`.trim();
};

/** Box CBM = L × B × H / 1 000 000 (assumes dimensions in cm → m³). */
export const computeBoxCbmFromDims = (length, breadth, height) => {
  const l = parseFloat(String(length ?? '').replace(',', '.'));
  const b = parseFloat(String(breadth ?? '').replace(',', '.'));
  const h = parseFloat(String(height ?? '').replace(',', '.'));
  if (!Number.isFinite(l) || !Number.isFinite(b) || !Number.isFinite(h)) return null;
  return (l * b * h) / 1000000;
};

export const formatBoxCbmDisplay = (length, breadth, height) => {
  const v = computeBoxCbmFromDims(length, breadth, height);
  if (v === null) return '—';
  return v.toFixed(4);
};

export const mainImageSrc = (product) => {
  const imgs = product?.images;
  if (!Array.isArray(imgs) || imgs.length === 0) return null;
  const main = imgs.find((i) => i.is_main);
  return (main || imgs[0])?.path || null;
};
